<template>
  <div class="checkout-member-block-years">
    <div class="form-group">
      <button
        type="button"
        class="store-cart-item__qty-minus"
        :disabled="usedYears === 1"
        @click="decreaseYears"
      >
        -
      </button>

      <input
        type="text"
        readonly
        :name="fieldName"
        :value="usedYears"
      >

      <button
        type="button"
        class="store-cart-item__qty-plus"
        :disabled="remainingYears === 0"
        @click="increaseYears"
      >
        +
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberBlockYears',

  props: {
    index: {
      type: Number,
      default: 0
    },

    usedYears: {
      type: Number,
      default: 0
    },

    remainingYears: {
      type: Number,
      default: 0
    },

    increaseYears: {
      type: Function,
      default: null
    },

    decreaseYears: {
      type: Function,
      default: null
    }
  },

  computed: {
    fieldName() {
      return `Membership[${this.index}][Years]`
    }
  }
}
</script>
